import { PullToRefresh, ListView, Button } from "antd-mobile-v2";
import ReactDOM from "react-dom";
import React, { Component } from "react";
import { getMattixList } from "./getList";
import "./index.less";
let pageIndex = 1;
export default class Matrix extends Component {
  constructor(props) {
    super(props);
    const dataSource = new ListView.DataSource({
      rowHasChanged: (row1, row2) => row1 !== row2,
    });

    this.state = {
      dataSource,
      refreshing: true,
      isLoading: true,
      height: document.documentElement.clientHeight,
      useBodyScroll: false,
    };
  }
  componentDidUpdate() {
    if (this.state.useBodyScroll) {
      document.body.style.overflow = "auto";
    } else {
      document.body.style.overflow = "hidden";
    }
  }

  componentDidMount() {
    const hei = this.state.height - ReactDOM.findDOMNode(this.lv).offsetTop;
    setTimeout(async () => {
      let numList = await getMattixList(pageIndex);
      this.rData = numList;
      this.setState({
        dataSource: this.state.dataSource.cloneWithRows(numList),
        height: hei,
        refreshing: false,
        isLoading: false,
      });
    }, 500);
  }

  onRefresh = () => {
    this.setState({ refreshing: true, isLoading: true });
    setTimeout(async () => {
      let numList = await getMattixList();
      pageIndex = 1;
      this.rData = numList;
      this.setState({
        dataSource: this.state.dataSource.cloneWithRows(this.rData),
        refreshing: false,
        isLoading: false,
      });
    }, 1000);
  };
  onEndReached = (event) => {
    if (this.state.isLoading && !this.state.hasMore) {
      return;
    }
    this.setState({ isLoading: true });
    setTimeout(async () => {
      let numList = await getMattixList(++pageIndex);
      this.rData = [...this.rData, ...numList];
      this.setState({
        dataSource: this.state.dataSource.cloneWithRows(this.rData),
        isLoading: false,
      });
    }, 1000);
  };

  render() {
    const row = (rowData, sectionID, rowID) => {
      return (
        <div
          key={rowID}
          style={{
            backgroundColor: "white",
            height: "2rem",
            width: "1.5rem",
          }}
          className="letter-item"
        >
          <div className="item-bgColor">
            <a
              href={`https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=${rowData.jumpPath}&scene=124#wechat_redirect`}
              target="_blank"
            >
              <img src={rowData.orgLogo ? rowData.orgLogo : ""} />
            </a>
          </div>
          <div className="item-text">{rowData.abbreviation}</div>
        </div>
      );
    };
    return (
      <div>
        <ListView
          key={this.state.useBodyScroll ? "0" : "1"}
          ref={(el) => (this.lv = el)}
          dataSource={this.state.dataSource}
          renderFooter={() => (
            <div style={{ padding: 10, textAlign: "center" }}>
              {this.state.isLoading ? "Loading..." : "没有更多了"}
            </div>
          )}
          renderRow={row}
          useBodyScroll={this.state.useBodyScroll}
          onEndReachedThreshold={20}
          style={
            this.state.useBodyScroll
              ? {}
              : {
                  height: this.state.height,
                  border: "1px solid #ddd",
                }
          }
          pullToRefresh={
            <PullToRefresh
              refreshing={this.state.refreshing}
              onRefresh={this.onRefresh}
            />
          }
          onEndReached={this.onEndReached}
          pageSize={10}
        />
      </div>
    );
  }
}
